module.exports = {
  PREDES_TRANSACTIONS_EDIT_REQUEST: 'PREDES_TRANSACTIONS_EDIT_REQUEST',
  PREDES_TRANSACTIONS_EDIT_SUCCESS: 'PREDES_TRANSACTIONS_EDIT_SUCCESS',
  PREDES_TRANSACTIONS_EDIT_FAILURE: 'PREDES_TRANSACTIONS_EDIT_FAILURE',
};
